<template>
  <Popup
    :active="isErrorPopupOpen"
    animation="fade"
    :transparentBg="false"
    :fullsize="false"
    :hasBg="false"
    :borderRadiusBySide="['16px', '16px', '16px', '16px']"
    v-bind="{ modalContainerStyles }"
    @close="close"
  >
    <ErrorAlert @hidePopup="close" />
  </Popup>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Popup from '@/components/popup/index.vue';
import ErrorAlert from '@/components/popup/error-alert.vue';

/*
 * The message popup for a failed request (`menu/updateMenu` with
 * `isErrorPopupOpen`). cock-fight.vue mounts its own; this one is for the
 * pages that do not render cock-fight.vue -- the desktop client and the mobile
 * Tài Xỉu page -- so a bet the API rejects is shown rather than swallowed.
 */
export default {
  name: 'BetErrorPopup',
  components: { Popup, ErrorAlert },
  computed: {
    ...mapGetters('menu', ['isErrorPopupOpen']),
    modalContainerStyles() {
      return {
        position: 'relative',
        width: '90%',
        maxWidth: '350px',
        height: '240px',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },
  },
  methods: {
    ...mapActions('menu', ['updateMenu']),
    close() {
      this.updateMenu({ isErrorPopupOpen: false, errorMsg: '' });
    },
  },
};
</script>
